<template>
  <div class="percentage-box">
    <div v-if="onlyValue" :class="{'show-txt-rest':readonly,'blur-border': isFoucs,'visible-onlyValue': Boolean(currentValue)}" class="table-select-box"  @click="getBlur">
      <template v-if="!isFoucs">
        <div class="table-select-onlyValue table-select-checkbox" v-if="editValue > 0">
          <span>{{getZeroNum(editValue, config.decimal_places - 0)}}</span>
          <span class="icon-percent">%</span>
        </div>
        <p v-else class="table-select-button">
          <span v-if="readonly">暂无</span>
          <span v-else><i class="el-icon-circle-plus"></i>添加</span>
        </p>
      </template>
      <el-input-number v-else class="only-value-percentage" clearable v-bind="$props" ref="inputLongText" @blur="setBlurFoucs()" v-model="editValue" @change="changeVal" :placeholder="config.component_desc_in_template" :controls="false" :precision="config.decimal_places - 0" :min="0" :max="100">
      </el-input-number>
    </div>
    <div v-else :class="{'show-txt-rest':readonly}"  @click="getBlur">
      <template v-if="!isFoucs">
        <div v-if="editValue" class="only-value show-txt">
          <span  :style="{'width':'100%','paddingLeft':'8px'}">{{getZeroNum(editValue, config.decimal_places - 0)}}<span class="icon-percent">%</span></span>
          <div class="close-icon" v-show="!readonly">
            <i class="el-icon-circle-close" @click.stop="clearChekc"></i>
          </div>
        </div>
        <span v-else class="add-txt" :class="{ readonly }">{{readonly ? '暂无' : '添加'}}</span>
      </template>
      <div v-else>
        <el-input-number clearable v-bind="$props" ref="inputLongText" @blur="setBlurFoucs()" v-model="editValue" @change="changeVal" :placeholder="config.component_desc_in_template" :controls="false" :precision="config.decimal_places - 0" :min="0" :max="100">
        </el-input-number>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Object, String, Number]
    },
    // 字段的配置信息
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 默认值
    defaultValue: {
      type: [Object, String, Number,Array],
      default: () => {
        return {}
      }
    },
    // 只读模式 没有权限
    readonly: {
      type: Boolean,
      default: false
    },
    // 编辑任务需设置true
    isEdit: {
      type: Boolean,
      default: false
    },
    // 列表模式下增加class 设置样式
    isTable: {
      type: Boolean,
      default: false
    },
    // 列表模式下使用
    onlyValue: {
      type: Boolean,
      default: false
    },
    isTemplate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: '',
      isFoucs: false,
      dataset: '',
      editValue: undefined
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue || undefined)
      }
    }
  },
  // watch: {
  //   defaultValue: {
  //     handler() {
  //       /**
  //       * 新增的时候
  //       *    defaultValue 使用默认值''
  //       *
  //       * 编辑的时候接口数据返回
  //       *    如果字段值是空值      defaultValue 使用默认值''
  //       *    如果字段值有值        defaultValue 是一个对象{field_value: 20}
  //       */
  //       if(this.isEdit) {
  //         if(this.defaultValue.length === 0) {
  //           this.editValue = undefined
  //         }else{
  //           this.editValue = this.defaultValue.field_value
  //         }
  //       }else{
  //         this.editValue = undefined
  //       }
  //       this.$emit('input', this.editValue)
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if(this.isTemplate) {
        this.editValue = this.defaultValue || undefined
        this.$emit("input", this.defaultValue)
      } else if (this.defaultValue && this.defaultValue.length > 0) {
        this.editValue = this.getDefaultValue(this.defaultValue) || undefined
        let val = this.getDefaultValue(this.defaultValue)
        // this.dataset = this.toThousands(val)
        this.$emit('input', val)
      }
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val[0].component_value || ''
      }
    },
    getMessage(res) {
      return `<span class="message-mixin-tip">将${res.field_name}修改为</span><span class="message-mixin-task">${res.new_data * 1 || `<span class="message-mixin-tip">无</span>`}</span>`
    },
    changeVal(val, lr) {
      this.$emit('input', val || '')
      this.$emit('change', val, lr)
    },
    getBlur() {
      if (this.readonly) return
      this.isFoucs = true
      this.$nextTick(() => {
        this.$refs.inputLongText.focus()
      })
    },
    setBlurFoucs() {
      this.isFoucs = false
    },
    clearChekc(){
      this.editValue = undefined
      this.$emit('input', '')
      this.$emit('change', undefined)
    }
  }
}
</script>

<style lang="scss">
.percentage-box {
  display: flex;
  align-items: center;
  height: 100%;
  &>div{
    height: 100%;
  }
  .icon-percent {
    margin-left: 2px;
  }
  .money-box-flex {
    display: flex;
    align-items: center;
  }
  .icon-money {
    margin-left: 10px;
  }
  .el-input__inner,
  .el-input,
  .el-input-number {
    text-align: left;
    width: 100%;
    max-width: 160px;
  }
  .el-input__inner{
    padding-right: 28px !important;
  }
  .el-input {
    position: relative;
    &::after {
      content: '%';
      position: absolute;
      right: 8px;
      top:50%;
      transform: translate(0,-50%);
    }
  }
  .only-value-percentage{
    height: 100%;
    .el-input,.el-input__inner{
      height: 100% !important;
    }
    .el-input__inner{
      border:0 none !important;
      background-color: #fff;
      padding-left:0;
    }
  }
}
</style>
